export enum Authentication {
  AccessToken = 'access-token',
  RefreshToken = 'refresh-token',
  ExpiryIn = 'expires-in',
}

export enum System {
  Locale = 'locale',
  Theme = 'theme',
  Layout = 'layout',
}

export enum Theme {
  Light = 'light',
  Dark = 'dark',
}
